/**
 * Collection of font families used throughout the application.
 */
export const fonts = {
  figtree: `figtree, helvetica, arial, sans-serif`,
};
